import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { Avatar, Box, Card, CardActionArea, CardContent, Grid, Typography, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { playerDisplayName } from "./players/PlayerDisplayNameLink";
var paths = [
    {
        icon: _jsx(EmojiEventsIcon, { sx: { fontSize: 40 } }),
        title: "League Admin",
        description: "I run a league and need to manage fixtures, standings, and teams.",
        to: "/leagues/create/",
        accent: "#F59E0B",
        tint: "rgba(245, 158, 11, 0.14)",
    },
    {
        icon: _jsx(GroupsIcon, { sx: { fontSize: 40 } }),
        title: "Team Manager",
        description: "I manage a team and want to track matches, stats, and players.",
        to: "/teams/create/",
        role: "team",
        accent: "#2563EB",
        tint: "rgba(37, 99, 235, 0.14)",
    },
    {
        icon: _jsx(SportsSoccerIcon, { sx: { fontSize: 40 } }),
        title: "Player",
        description: "I'm a player and want to join a team and track my performance.",
        to: "/search/teams",
        role: "player",
        accent: "#16A34A",
        tint: "rgba(22, 163, 74, 0.14)",
    },
];
export var Welcome = function (_a) {
    var player = _a.player, onSelectRole = _a.onSelectRole;
    var navigate = useNavigate();
    var name = playerDisplayName(player);
    var handleSelect = function (path) {
        if (path.role && onSelectRole) {
            onSelectRole(path.role);
        }
        else {
            navigate(path.to);
        }
    };
    return (_jsxs(Box, { sx: { textAlign: "center", py: { xs: 3, sm: 6 } }, children: [_jsxs(Typography, { variant: "h3", component: "h1", sx: {
                    fontWeight: 800,
                    letterSpacing: "-0.02em",
                    mb: 1.5,
                    fontSize: { xs: "2rem", sm: "2.75rem" },
                }, children: ["Welcome to Log.Soccer", name ? ", ".concat(name) : "", "!"] }), _jsx(Typography, { variant: "h6", color: "text.secondary", sx: { mb: { xs: 4, sm: 6 }, fontWeight: 400 }, children: "What brings you here?" }), _jsx(Grid, { container: true, spacing: { xs: 2, sm: 3 }, justifyContent: "center", children: paths.map(function (path) { return (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, children: _jsx(Card, { variant: "outlined", sx: {
                            height: "100%",
                            borderRadius: 3,
                            overflow: "hidden",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
                            "&:hover": {
                                transform: "translateY(-6px)",
                                boxShadow: 8,
                                borderColor: path.accent,
                            },
                        }, children: _jsxs(CardActionArea, { "aria-label": path.title, onClick: function () { return handleSelect(path); }, sx: { height: "100%" }, children: [_jsx(Box, { sx: { height: 6, bgcolor: path.accent } }), _jsxs(CardContent, { sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        height: "100%",
                                        pt: 4,
                                        pb: 3,
                                        px: 3,
                                    }, children: [_jsx(Avatar, { sx: {
                                                width: 76,
                                                height: 76,
                                                mb: 2,
                                                bgcolor: path.tint,
                                                color: path.accent,
                                            }, children: path.icon }), _jsx(Typography, { variant: "h6", sx: { fontWeight: 700, mb: 1 }, children: path.title }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { flexGrow: 1, mb: 2 }, children: path.description }), _jsxs(Box, { sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 0.25,
                                                color: path.accent,
                                                fontWeight: 700,
                                            }, children: [_jsx(Typography, { variant: "button", sx: { fontWeight: 700 }, children: "Get started" }), _jsx(KeyboardArrowRightIcon, { fontSize: "small" })] })] })] }) }) }, path.title)); }) })] }));
};
